<template>
  <div id="app">
    <transition name="TransWidth">
        <router-view/>
    </transition>
    <img src="@/assets/top.png" class="ToTop" @click="topTop">
  </div>
</template>
<script>
export default {
  methods:{
    topTop(){
     let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    }
  }
}
</script>
<style lang="scss">
body{
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1260px;
  width: 100%;
}
.ToTop{
  z-index: 999999;
  position: absolute;
  right: 20px;
  // bottom:0;
  margin-top:-75px;
  width:50px;
  height: 50px;
  &:hover{
    cursor: pointer;
  }
}
.ContentBox{
  // min-width: 1260px;
  // height: 100%;
  // width: 100%;
  text-align: center;
  // position: relative;
}
.commonBox{
  text-align: center;
  min-width: 1260px;
  width:1260px;
  padding: 0 calc(calc(100% - 1260px)  / 2);
}
// 路由过渡动画
.TransWidth-enter-active {
   animation: TransWidth-in .5s;
}
.TransWidth-leave-active {
  animation: TransWidth-in .5s reverse;
}
@keyframes TransWidth-in {
  // 0% {
  //   transform:translateX(0);
  // }
  // 100% {
  //   transform:translateX(100%);
  // }
    0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
// 申请试用的过渡
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
